export default __webpack_public_path__ + "static/media/Tilly_9781408333792.d544541d.jpg";